import React, { useEffect, useState } from "react";
import style from "./PreviewWelcomeScreen.module.scss";
import { loadingScreenImage } from "src/helper/helper";
import { useIsLoadingPreview } from "@/states/ui.state";
import { useRouter } from "next/router";
const PreviewWelcomeScreen = (data: any) => {
  const {
    setIsLoadingPreview,
    isLoadingPreview
  } = useIsLoadingPreview();
  const router = useRouter();
  const [initialLoading, setInitialLoading] = useState(true);
  useEffect(() => {
    router.pathname.includes("customize") ? setIsLoadingPreview(false) : setIsLoadingPreview(true);
    setInitialLoading(false);
  }, []);
  useEffect(() => {
    if (isLoadingPreview) {
      let x = setTimeout(() => {
        setIsLoadingPreview(false);
      }, 2500);
      return () => clearTimeout(x);
    }
  }, [setIsLoadingPreview, isLoadingPreview]);
  return <>
      {isLoadingPreview && !initialLoading ? <div className={style.preview_box}>
          <div className={style.loadingLine} style={{
        "--color": data?.data.payload.design_colors_primary
      } as React.CSSProperties} />
          <div dangerouslySetInnerHTML={{
        __html: loadingScreenImage(data?.data.files, data?.data.qr_type || data?.data.type)
      }} />
        </div> : <></>}
    </>;
};
export default PreviewWelcomeScreen;